<template>
<div v-if="detailLoading">  </div>
  <pt-active-sign-notes v-else class="pt-active-sign-notes__withData" :name="name" :id="id" :signDetail="signDetail" :hospitalList="hospitalList"
  :provinceList="provinceList" :areaList="areaList" :readPersonnelList="readPersonnelList" :exportLoading="exportLoading" @exportSign="exportSign" @confirm="confirm" ref="table" @reportRead="reportRead"
  @invalid="invalid" v-loading="invalidLoading||detailLoading"></pt-active-sign-notes>

</template>

<script>
import PtActiveSignNotes from './index'
export default {
  name: 'pt-active-sign-notes__withData',
  components: {
    'pt-active-sign-notes': PtActiveSignNotes
  },
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      signDetail: {},
      hospitalList: [],
      provinceList: [],
      areaList: [],
      readPersonnelList: [],
      exportLoading: false,
      invalidLoading: false,
      detailLoading: false
    }
  },
  methods: {
    invalid (row) {
      this.invalidLoading = true
      this.$store.dispatch('getSignInvalid', row.id).then(res => {
        this.$message.success('设置成功')
        this.$nextTick(_ => {
          return this.$refs.table.getTableData
        })
        this.invalidLoading = false
      }).catch(err => {
        this.$message.error(err || '设置预约报名失效失败')
        this.$nextTick(_ => {
          return this.$refs.table.getTableData
        })
        this.invalidLoading = false
      })
    },
    exportSign (data) {
      this.exportLoading = true
      this.$store.dispatch('exportSign', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出失败')
      })
    },
    getSignDetail () {
      this.detailLoading = true
      this.$store.dispatch('getSignDetail', this.id).then(res => {
        this.detailLoading = false
        this.signDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取报名详情失败')
      })
    },
    reportRead (val) {
      if (!(val.unscrambleDetail && val.unscrambleDetail.content)) {
        this.$message.error('请录入解读详情')
      } else if (!val.repurchaseIntention) {
        this.$message.error('请录入复购意向')
      } else {
        this.invalidLoading = true
        this.$store.dispatch('reportInterpreted', val.id).then(res => {
          this.$message.success('预约解读成功')
          this.$refs.table.resetPage()
          this.invalidLoading = false
        }).catch(err => {
          this.$message.error(err || '预约解读失败')
          this.invalidLoading = false
        })
      }
    },
    confirm (val) {
      this.$store.dispatch('confirmRegistration', val.id).then(res => {
        this.$message.success('确认报名成功')
        this.$refs.table.resetPage()
      }).catch(err => {
        this.$message.error(err || '确认报名失败')
      })
    },
    getHospitalList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getHospitalList', data).then(res => {
        this.hospitalList = res.data
      }).catch(err => {
        this.$message.error(err || '获取医院列表失败')
      })
    },
    getDivision () {
      let data = {
        provinceGbCode: 0,
        cityGbCode: 0
      }
      this.$store.dispatch('getDivision', data).then(res => {
        this.provinceList = res
      }).catch(err => {
        this.$message.error(err || '获取省份列表失败')
      })
    },
    getReportAreaList () {
      this.$store.dispatch('getReportAreaList').then(res => {
        this.areaList = res
      }).catch(err => {
        this.$message.error(err || '获取省份列表失败')
      })
    },
    getReadPersonnelList () {
      this.$store.dispatch('getReadPersonnelList').then(res => {
        this.readPersonnelList = res
      }).catch(err => {
        this.$message.error(err || '获取省份列表失败')
      })
    }
  },
  created () {
    this.getSignDetail()
    // this.getHospitalList()
    this.getDivision()
    this.getReportAreaList()
    this.getReadPersonnelList()
  }
}
</script>
